import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo_00.jpg";

const data: ReplicaItemType = {
  id: "advanced-potion-making-v2-prototype-full",
  name: "Full Prototype Advanced Potion Making V2 - Prince's Copy",
  nameFormatted: {
    primary: "Full Prototype",
    secondary: "Advanced Potion Making V2",
    tertiary: "Prince's Copy",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
